<template>
  <v-container fluid>
    <Header title="Rezanie materiálu" subtitle="Cenová ponuka na rezanie materialu." />

    <v-layout row wrap fill-height>
      <v-flex lg2 xs12 pa-2 order-lg1 order-xs3>
        <v-flex xs12>
          <v-btn color="primary" dark @click="optimizing()">Spustiť optimalizáciu</v-btn>
        </v-flex>
        <v-card flat color="transparent">
          <v-card-text>
            <span class="title text-md-center">Optimalizácia</span>

            <OptimizationGallery
              :optimizationResultItems="optimizationItems"
              empty="Zadajte položky a vyskúšajte optimalizáciu"
            />
            <OptimizationSummary :optimizationSummary="optimizationItems" />
          </v-card-text>
          <v-card-actions>
            <v-flex xs12 class="text-xs-right" v-if="optimizationItems != null">
              <v-btn color="primary" dark @click="submit()">Objednať</v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex lg7 xs12 pa-2 order-lg2 order-xs1>
        <CuttingModul ref="cuttingModul" />
      </v-flex>

      <v-flex lg3 xs12 pa-2 order-lg3 order-xs2>
        <CuttingItem @editItem="editItem" />
        <v-flex xs12 class="text-xs-right">
          <v-btn color="primary" @click="deleteOptimization()">Zmazat údaje rezania</v-btn>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import * as types from '@/store/types'
import Header from "@/components/widgets/Header";
import OptimizationSummary from "@/views/cutting/components/OptimizationSummary";
import OptimizationGallery from "@/views/cutting/components/OptimizationGallery";
import CuttingItem from "@/views/cutting/components/CuttingItem";
import CuttingModul from "@/views/cutting/components/CuttingModul";
import Controller from "@/mixins/controlsMixins";
import OrderService from "@/services/OrderService";
import * as types from "@/store/types";
export default {
  name: "Cutting",
  components: {
    Header,
    OptimizationGallery,
    CuttingModul,
    CuttingItem,
    OptimizationSummary
  },
  mixins: [Controller],
  data() {
    return {
      // optimizationData: [],
    };
  },
  computed: {
    optimizationItems() {
      console.log(this.$store.getters.optimizationItems);
      return this.$store.getters.optimizationItems;
    }
  },
  methods: {
    optimizing() {
      if (this.$store.getters.cuttingItems == 0) {
        this.openGlobalAlert("Prosím zadajte dielce.", "warning");
        return;
      }

      if (!this.$store.getters.isAuthenticated) {
        this.openGlobalAlert("Najskôr sa prihláste.", "warning");
        return;
      }

      this.openGlobalLoader("Spracováva sa ...");

      new OrderService()
        .postOptimization(this.$store.getters.cuttingItems)
        .then(response => {
          // this.optimizationData = response.data
          this.$store.commit(
            types.ADD_OPTIMIZATION_ITEMS_TO_STORE,
            response.data
          );
          this.openGlobalAlert("Optimalizácia bola úspešná", "success");
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 401) return;
          this.openGlobalAlert(
            "Optimalizácia sa nepodarila. Skúste neskor.",
            "error"
          );
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    submit() {
      if (this.$store.getters.cuttingItems == 0) {
        this.openGlobalAlert("Prosím zadajte dielce.", "warning");
        return;
      }

      if (!this.$store.getters.isAuthenticated) {
        this.openGlobalAlert("Najskôr sa prihláste.", "warning");
        return;
      }

      if (!confirm("Chcete vytvoriť objednávku?")) {
        return;
      }

      this.openGlobalLoader("Spracováva sa ...");

      new OrderService()
        .postCuttingOrder(this.$store.getters.cuttingItems)
        .then(response => {
          // this.optimizationData = response.data
          this.$store.commit(
            types.ADD_OPTIMIZATION_ITEMS_TO_STORE,
            response.data
          );
          this.openGlobalAlert("Objednávka bola spracovaná", "success");
          this.deleteOptimization();
        })
        .catch(error => {
          console.error(error);
          this.openGlobalAlert(
            "Objednávku sa nepodarilo spracovať. Skúste neskor.",
            "error"
          );
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    deleteOptimization() {
      if (!confirm("Chcete vymazať položky rezania?")) {
        return;
      }
      this.$store.commit(types.REMOVE_ALL_ITEMS_FROM_STORE);
    },
    editItem(item) {
      this.$store.commit("removeOptimizationItems");
      this.$refs.cuttingModul.editItem(item);
    }
  }
};
</script>

<style>
</style>